<div class="__wrapper">
  @if (inputWrapper.isLabel()) {
    <label [for]="inputWrapper.randomInputId()" class="__label">
      <ng-container [ngTemplateOutlet]="labelRef"></ng-container>
    </label>
  }
  @if (!inputWrapper.isLabel()) {
    <span class="__label">
      <ng-container [ngTemplateOutlet]="labelRef"></ng-container>
    </span>
  }
</div>
<ng-template #labelRef>
  @if (base.label || base.labelTemplate) {
    <span class="__label-text">
      <span>
        <ng-container [ngTemplateOutlet]="base.labelTemplate || defaultLabelTemplateRef"></ng-container>
      </span>
      @if (base.help) {
        <ui-form-field-help
          [extended]="base.extendedHelpTooltip()"
          [help]="base.help"
          [tooltipPosition]="base.helpTooltipPosition()">
        </ui-form-field-help>
      }
    </span>
  }
</ng-template>
<ng-template #defaultLabelTemplateRef>
  <span [innerHTML]="base.label"></span>
  @if (isRequired() || base.addAsteriskToFakeRequiredLabel()) {
    <span class="text-(--text-status-error) ml-[0.2em]">*</span>
  }
</ng-template>
<!-- kotva pro absolutně umístěné ikony a akce uvnitř pole (ui-input, ui-number-input) -->
<span
  class="__input-wrapper relative block"
  [class.touched-invalid]="controlTouched && errors.errors"
  [class.submitted-invalid]="inputWrapper.submitted() && errors.errors">
  <ng-content></ng-content>
</span>
@if (base.hintTemplate || base.hint || text.maxLength || errors.errors) {
  <div
    class="flex text-(length:--font-size-body-s) text-(--text-secondary)"
    [class]="
      base.hintTemplate ||
      base.hint ||
      ((inputWrapper.submitted() || base.forceShowValidationErrors() || controlTouched) && errors.errors)
        ? 'justify-between'
        : 'justify-end'
    ">
    <span>
      @if ((base.hintTemplate || base.hint) && !(inputWrapper.submitted() && errors.errors)) {
        <span class="mt-1.25 block">
          @if (base.hint) {
            {{ base.hint }}
          }
          @if (base.hintTemplate) {
            <ng-container [ngTemplateOutlet]="base.hintTemplate"></ng-container>
          }
        </span>
      }
      @if ((inputWrapper.submitted() || base.forceShowValidationErrors() || controlTouched) && errors.errors) {
        <ui-form-error [customErrorLabels]="base.errorLabels()" [errors]="errors.errors"> </ui-form-error>
      }
    </span>
    @if (text.maxLength) {
      <span> {{ inputWrapper.valueLength() }} / {{ text.maxLength }} </span>
    }
  </div>
}
